import React from 'react'

import * as S from './styled'

const Phone = () => (
  <S.PhoneWrapper>
    <S.PhoneImage src={'/images/phone.png'} />
  </S.PhoneWrapper>
)

export default Phone
